export enum AuthorizationScenario {
    UnlockAccount,
    AuthorizeAction,
    AuthenticateUserUsingAppToken,
    AuthenticateUserUsingSmsToken,
    Login,
    DownloadApp,
    TokenOption,
    AddBankAccount,
    AddBankAccountOperationalLimit,
    DeleteBankAccount,
    ChangeEmail,
    ChangeLimitRisk,
    CancelPackage,
    SubmitPackage,
    ChangePassword,
    ChangeToZeroBrokerage,
    ChangeAddress,
    ChangeIncome,
    ChangePersonalData,
    ChangeName,
    ChangeBusinessAddress,
    ChangeDataBusiness,
    ChangeBusinessIncomeDequity,
    ChangeSocietalStruture
}
